// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"843":"5bf5dc3be23d29b7","888":"766982aed0f57492"}[chunkId] + ".css";
};